import _ from "lodash";

const reducer = async (action, data, state, prevState) => {
  switch (action) {
    case "GET":
      let listIZobraz = _.cloneDeep(prevState.allListIZobraz)
      let listGridIZobraz = _.cloneDeep(prevState.allListGridIZobraz);
      if (state.IAkcFrmSkupUz.detailData.Akc && !state.IAkcFrmSkupUz.detailData.Akc.NMaska) {
        listGridIZobraz = listGridIZobraz.filter(x => x.I_HOD !== 2)
        listIZobraz.data = listIZobraz.data.filter(x => x.I_HOD !== 2)
      }

      return { ...state, listIZobraz, listGridIZobraz }

    case "GET_SCHEMA":
      const allListIZobraz = _.cloneDeep(state.listIZobraz)
      const allListGridIZobraz = _.cloneDeep(state.listGridIZobraz)
      return { ...state, allListGridIZobraz, allListIZobraz }

    default:
      return state;
  }

}

export default reducer;